import { render, staticRenderFns } from "./LayoutAnimationSettingsModal.vue?vue&type=template&id=16a1916d&scoped=true"
import script from "./LayoutAnimationSettingsModal.vue?vue&type=script&lang=js"
export * from "./LayoutAnimationSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./LayoutAnimationSettingsModal.vue?vue&type=style&index=0&id=16a1916d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a1916d",
  null
  
)

export default component.exports